<!-- =========================================================================================
  File Name: Objects.vue
  Description: Apps Objects
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="apps-objects" class="data-list-container">

    <!-- <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" /> -->

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="objects">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Действия</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center text-danger">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Удалить</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-success border border-solid border-success" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-success">Создать</span>
          </div>

          <div class="btn-upload p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary" @click="objects_load">
              <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Обновить</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ objects.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : objects.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="oid">ID</vs-th>
        <vs-th sort-key="name">Название</vs-th>
        <vs-th sort-key="ident">Сер. номер</vs-th>
        <vs-th sort-key="number">SIM-карта</vs-th>
        <vs-th sort-key="online">Подключение</vs-th>
        <vs-th>Статус</vs-th>
        <vs-th sort-key="type">Тип</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="object-oid">{{ tr.oid }}</p>
            </vs-td>

            <vs-td>
              <p class="object-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="object-ident">{{ tr.ident }}</p>
            </vs-td>

            <vs-td>
              <p class="object-ident">{{ tr.number }}</p>
            </vs-td>

            <vs-td>
                <p class="object-online" :class="'text-' + network_color(tr.online)">{{ tr.actual | sectime }}</p>
              
              <!-- <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + network_color(tr.online)"></div>
                <p class="object-online">{{ tr.online | network_status }} - {{ tr.actual | sectime }}</p>
              </span> -->
            </vs-td>

            <vs-td>
              <p class="object-status flex">
                <feather-icon icon="RadioIcon" class="sticon" :class="object_status_gsm(tr)" />
                <feather-icon icon="MapPinIcon" class="sticon" :class="object_status_gps(tr)" />
                <feather-icon :icon="object_icon_move(tr)" class="sticon" :class="object_status_move(tr)" />
                <feather-icon icon="DownloadIcon" class="sticon mr-0 text-primary" /><span class="mr-2" v-html="object_status_input(tr)"></span>
                <feather-icon icon="UploadIcon" class="sticon mr-0 text-primary" /><span class="mr-2" v-html="object_status_output(tr)"></span>
              </p>
            </vs-td>

            <vs-td>
              <p class="object-type">{{ tr.type }}</p>
            </vs-td>


            <!-- <vs-td>
              <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" />
            </vs-td>

            <vs-td>
              <vs-chip :color="getOrderStatusColor(tr.order_status)" class="product-order-status">{{ tr.order_status | title }}</vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-price">${{ tr.price }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
            </vs-td> -->

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
// import DataViewSidebar from '../DataViewSidebar.vue'
// import moduleDataList from "@/store/data-list/moduleDataList.js"

export default {
  // components: {
  //   DataViewSidebar
  // },
  data() {
    return {
      selected: [],
      objects: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      timer: 0,
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    // products() {
    //   return this.$store.state.dataList.products
    // },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.objects.length
    }
  },
  created() {
    this.objects_load()
    // this.timer = setTimeout(this.objects_update, 5000)
  },
  destroyed() {
    // if (this.timer) {
    //   clearTimeout(this.timer)
    //   this.timer = 0
    // }
  },
  methods: {
    objects_load() {
      this.$api.object(true, 'list', null, (res) => {
        if (res.success && res.msg == 'ok') {
          this.objects = res.data
          console.log(this.objects)
        }
      })
    },
    objects_update() {
      this.$api.object(false, 'list', null, (res) => {
        if (res.success && res.msg == 'ok') {
          this.objects = res.data
          console.log(this.objects)
        }
        // this.timer = setTimeout(this.objects_update, 5000)
      })
    },
    
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor(status) {
      if(status == 'on_hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num > 70) return "primary"
      if(num > 50) return "warning"
      return "danger"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    network_color: function (value) {
      return value ? 'success' : 'danger'
    },
    object_status_gsm(item) {
      if (!item.data) return "text-base"
      if(item.data.mqua > 3) return "text-success"
      if(item.data.mqua > 1) return "text-warning"
      return "text-danger"
    },
    object_status_gps(item) {
      if (!item.data) return "text-base"
      if(item.data.gsat) {
        if(item.data.gsat > 5) return "text-success"
        if(item.data.gsat > 2) return "text-warning"
        return "text-danger"
      }
      if(item.data.gsta) return "text-success"
      return "text-danger"
    },
    object_icon_move(item) {
      if (!item.data) return "CircleIcon"
      if (item.data.gspe > 0) {
        return "ArrowRightCircleIcon"
      }
      return "CircleIcon"
    },
    object_status_move(item) {
      if (!item.data) return "text-base"
      if (item.data.gspe > 0) {
        return "text-success"
      }
      return "text-base"
    },
    object_status_input(item) {
      if (!item.data) return "00"
      let val = 0
      if (item.data.din1) {
        val = item.data.din1
      } else if (item.data.inputs) {
        val = item.data.inputs
      } else if (item.data.acc) {
        val = item.data.acc
      }
      let val1 = val & 1
      let val2 = val >> 1 & 1

      let cl1 = val1 ? 'text-danger strong' : 'text-base'
      let cl2 = val2 ? 'text-danger strong' : 'text-base'

      return '<span class="' + cl2 + '">' + val2 + '</span>' + '<span class="' + cl1 + '">' + val1 + '</span>'
    },
    object_status_output(item) {
      if (!item.data) return "00"
      let val = 0
      if (item.data.dou1) {
        val = item.data.dou1
      } else if (item.data.outputs) {
        val = item.data.outputs
      } else if (item.data.relay) {
        val = item.data.relay
      }
      let val1 = val & 1
      let val2 = val >> 1 & 1

      let cl1 = val1 ? 'text-danger strong' : 'text-base'
      let cl2 = val2 ? 'text-danger strong' : 'text-base'

      return '<span class="' + cl2 + '">' + val2 + '</span>' + '<span class="' + cl1 + '">' + val1 + '</span>'
    },
    
  },
  // created() {
  //   if (!moduleDataList.isRegistered) {
  //     this.$store.registerModule('dataList', moduleDataList)
  //     moduleDataList.isRegistered = true
  //   }
  //   this.$store.dispatch("dataList/fetchDataListItems")
  // },
  mounted() {
    this.isMounted = true;
  },
  filters: {
    network_status: function (value) {
      return value ? 'в сети' : 'не в сети'
    },
    sectime: function (seconds) {
      let hide_sec = false;
      let time = '';
      let years = 0;
      let days = 0;
      let hours = 0;
      let mins = 0;
      if (seconds >= 60) {
        if (seconds >= 3600) {
          if (seconds >= 86400) {

            if (seconds >= 31536000) {
              years = parseInt(seconds / 31536000);
              seconds -= years * 31536000;
              let l = years.toString().slice(-1);
              if (l == 1) {
                time += years + ' год ';
              } else if (l > 0 && l < 5) {
                  time += years + ' года ';
              } else {
                time += years + ' лет ';
              }
            }
            days = parseInt(seconds / 86400);
            seconds -= days * 86400;
            let l = days.toString().slice(-1);
            if (days == 0) time += days + ' д. ';
            else if (days >= 11 && days <= 14) {
              time += days + ' дней ';
            } else if (l == 1) {
              time += days + ' день ';
            } else if (l > 0 && l < 5) {
                time += days + ' дня ';
            } else {
              time += days + ' дней ';
            }
          }
          hours = parseInt(seconds / 3600);
          seconds -= hours * 3600;
          if (hours > 0 && years == 0 && days < 3) time += hours + ' ч. ';
        }
        mins = parseInt(seconds / 60);
        seconds -= mins * 60;
        if (years == 0 && days == 0 &&  mins > 0 && hours < 12) time += mins + ' мин. ';
        if (!hide_sec) {
          if (days == 0 && hours == 0 && mins < 30) {
            let s = parseInt(seconds);
            if (s < 0) s = 0;
            if (s) {
              time += (s + ' сек.');
            }
          }
        }
      } else {
        if (hide_sec) time = 'менее минуты';
        else {
          let s = parseInt(seconds);
          if (s < 0) s = 0;
          if (s) {
            time += (s + ' сек.');
          }
        }
      }
      return time;
    },
  },
}
</script>

<style lang="scss">
#apps-objects {
  .strong {
    font-weight: 600;
  }
  .sticon {
    margin-right: .4rem;
    width: 1.4rem;
    height: 1.4rem;
  }
  // .object-status {
  //   display: flex;
  // }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .object-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 .8rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            // padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
